// extracted by mini-css-extract-plugin
export default {"word":"lessonText_word__AdFC4","wordButton":"lessonText_wordButton__GN9Yd"};